"use client";

import { useState } from "react";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch("/api/users/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      if (!res.ok) {
        setError("Email ou mot de passe incorrect.");
        setLoading(false);
        return;
      }
      const params = new URLSearchParams(window.location.search);
      window.location.href = params.get("redirect") || "/app";
    } catch {
      setError("Une erreur est survenue. Réessayez.");
      setLoading(false);
    }
  }

  return (
    <div className="auth-wrap">
      <form className="auth-card" onSubmit={submit}>
        <div className="auth-brand">
          <div className="auth-logo">Q</div>
          <div>
            <div className="auth-title">Questionnaires</div>
            <div className="auth-sub">Espace de création — Impact IA</div>
          </div>
        </div>
        <a
          className="btn btn--primary btn--lg"
          href="/sso/start"
          style={{ width: "100%", textAlign: "center" }}
          onClick={(e) => {
            e.preventDefault();
            const r = new URLSearchParams(window.location.search).get("redirect");
            window.location.href = "/sso/start" + (r ? `?redirect=${encodeURIComponent(r)}` : "");
          }}
        >
          Se connecter avec Impact-IA
        </a>
        <div style={{ display: "flex", alignItems: "center", gap: 10, margin: "12px 0", color: "#9aa0ae", fontSize: 12 }}>
          <span style={{ flex: 1, height: 1, background: "#e3e6ee" }} />
          ou par email
          <span style={{ flex: 1, height: 1, background: "#e3e6ee" }} />
        </div>
        <label className="field">
          <span className="field__label">Email</span>
          <input className="input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
        </label>
        <label className="field">
          <span className="field__label">Mot de passe</span>
          <input className="input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </label>
        {error && <div className="auth-error">{error}</div>}
        <button className="btn btn--primary btn--lg" type="submit" disabled={loading} style={{ width: "100%" }}>
          {loading ? "Connexion…" : "Se connecter"}
        </button>
      </form>
    </div>
  );
}
